import { AppRequestsTable } from '../../../apps/components/AppRequestsTable/AppRequestsTable';

export function PublisherAppRequestsTable({ publisherId }: { publisherId: string }) {
  return <AppRequestsTable publisherId={publisherId} />;
}
